import type { GetServerSidePropsContext } from "next/types";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import ToolsPageLayout from "components/ToolsPageLayout";
import type { NextPageWithLayout } from "pages/_app";
import Error from "pages/_error";
import {
  authenticatedAccountUrl,
  sessionFromContextCookie,
} from "hooks/useAuthentication";
import { baseFetcher } from "utils/baseFetcher";
import { isSsr } from "utils/isSsr";

const ToolsPage: NextPageWithLayout = () => {
  return <ToolsPageLayout />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const session = sessionFromContextCookie(context);
    const accountUrl = authenticatedAccountUrl(
      session?.authenticated?.account_id
    );

    const account =
      isSsr(context) && accountUrl
        ? await baseFetcher(accountUrl, context).catch(() => ({}))
        : null;

    return {
      props: {
        fallback: { [accountUrl]: account },
      },
    };
  } catch (error: any) {
    console.error("[slug].tsx ~ getServerSideProps Tools Page ~ error", error);
    Bugsnag.notify(error);
    return {
      props: {
        fallback: {},
      },
    };
  }
}

ToolsPage.getLayout = (page, { pageProps }) => {
  const { fallback, errorCode } = pageProps;

  if (errorCode) return <Error statusCode={errorCode} />;

  return <SWRConfig value={{ fallback }}>{page}</SWRConfig>;
};

export default ToolsPage;
